import { useRef } from "react";
import { useSetRecoilState } from "recoil";
import { mediaState } from "../recoil";

const MediaConfig = () => {
    const setMedia = useSetRecoilState(mediaState);
    const $ = useRef(false);
    if ($.current === false) {
        $.current = true;
        const sm = window.matchMedia(`(max-width: 779px)`);
        const md = window.matchMedia(`(min-width: 780px) and (max-width: 1279px)`);
        const lg = window.matchMedia(`(min-width: 1280px)`);
        sm.addEventListener("change", (event) => {
            if (event.matches) setMedia({ sm: true, md: false, lg: false });
        });
        md.addEventListener("change", (event) => {
            if (event.matches) setMedia({ sm: false, md: true, lg: false });
        });
        lg.addEventListener("change", (event) => {
            if (event.matches) setMedia({ sm: false, md: false, lg: true });
        });
    }
    return null;
};

export default MediaConfig;
